<template>
  <div>
    <div class="head-box">
      <h4>C端商品列表</h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- v-if="osg.has('Wares,new')" -->
        <el-button type="primary" @click="doNew" class="c-m-l-10">
          新增商品
        </el-button>
        <!-- v-if="osg.has('Wares,audit')" -->
        <!-- <el-dropdown class="c-m-l-10" @command="audit">
          <el-button type="primary">
            审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">审核通过</el-dropdown-item>
            <el-dropdown-item command="2">审核不通过</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:orgName|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                sortField: 'order,_id',
                sortOrder: 'asc',
                beanName: 'wares',
                title: '商品管理'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <!-- v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId" -->
          <div style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;">
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectRows"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column type="selection" width="55" fixed></el-table-column>
          <!-- 动态列 -->
          <c-table :fields="extFields">
            <template slot="classifyId">
              <el-table-column
                prop="classifyId"
                label="商品分类"
                :formatter="formatClassify"
              ></el-table-column>
            </template>
            <template slot="typeId">
              <el-table-column prop="typeId" label="商品" width="300px" show-overflow-tooltip>
                <template slot-scope="scope">
                  <template v-if="scope.row.type == '1'">
                    {{ osg.codelabelForArray('materials', scope.row.typeId) }}
                  </template>
                  <template v-if="scope.row.type == '2'">
                    {{ osg.codelabelForArray('measure', scope.row.typeId) }}
                  </template>
                  <template v-if="scope.row.type == '3'">
                    {{ osg.codelabelForArray('projPackages', scope.row.typeId) }}
                  </template>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <!--  v-if="osg.has('wares,edit') || osg.has('wares,enable') || osg.has('wares,remove')" -->
          <el-table-column fixed="right" width="110" label="操作">
            <template slot-scope="scope">
              <el-dropdown class="c-m-l-10">
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- v-if="osg.has('wares,edit')" -->
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <!-- v-if="osg.has('wares,remove')" -->
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <!-- <el-dialog title="材料" :visible.sync="openDetail" destroy-on-close @closed="doInit"> -->
    <el-dialog title="商品" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        @changeForm="osg.changeForm"
      >
        <template slot="type">
          <el-select
            v-model="formData.type"
            placeholder="选择类型"
            size="small"
            @change="formData.typeId = []"
            style="width:100%"
          >
            <el-option
              v-for="item in options.waresType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="typeId">
          <el-select
            v-show="formData.type == 1"
            v-model="formData.typeId"
            :remote-method="getMaterial"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="可搜索产品"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, i) in options.materials"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
          <el-select
            v-show="formData.type == 2"
            v-model="formData.typeId"
            :remote-method="getMeasure"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="可搜索产品"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, i) in options.measure"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
          <el-select
            v-show="formData.type == 3"
            v-model="formData.typeId"
            :remote-method="getProjPackages"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="可搜索产品"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, i) in options.projPackages"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </template>

        <template slot="classifyId">
          <el-cascader
            v-model="formData.classifyId"
            :options="options.classify"
            :props="{ checkStrictly: true, emitPath: false, label: 'name', value: '_id' }"
            clearable
          ></el-cascader>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'wares',
  data() {
    window.$this = this;
    return {
      type: '',
      tenantId: '',
      loginOrgId: '',
      name: 'wares',
      refresh: true,
      fpi: {},
      selectedRows: [],
      searchValue: '',
      openDetail: false,
      formData: {
        typeId: [],
        exts: { details: [] }
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_unit: { codeId: 'UNIT' },
        codecfg_waresType: { codeId: 'waresType' },
        allClassify: [],
        materials: [],
        measure: [],
        projPackages: []
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        // downloadUrl: this.osg.downloadUrl,
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        // 新增
        limit: 10
      }
      // materialsArr: []
    };
  },
  mounted() {
    // 当前用户tenantId
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;

    this.doInit();
    this.osg.getFields('wares', () => {
      this.osg.getFpi();
      this.getMaterial();
      this.getMeasure();
      this.getProjPackages();
      this.getData();
    });
    this.getAllClassify();
    this.getClassify();
  },
  methods: {
    formatMeasure(row, column, cellValue) {
      return this.osg.codelabelForArray('measure', cellValue);
    },
    // 材料
    formatMaterialIds(row, column, cellValue) {
      return this.osg.codelabelForArray('materials', cellValue);
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatCascade(option, arr) {
      let str = '';
      let opts = this.$util.deepCopy(this.options[option]);
      // 单选级联 有几级循环几次
      for (var i = 0; i < arr.length; i++) {
        for (var opt of opts) {
          if (opt.value == arr[i]) {
            str += (opt.label || opt.name) + '、';
            opts = this.$util.deepCopy(opt.children);
            break;
          }
        }
      }
      return str.slice(0, str.length - 1);
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      //
      if (this.$refs['formData']) {
        this.$refs['formData'].resetFields();
      }
      this.upload.data = {};
      this.formData = { typeId: [], images: [], exts: {} };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:orgName|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('wares/query.do', params, res => {
        res.data.map(item => {
          item.typeId = item.typeId.split(',');
        });
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        // 赋值
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      //
      row = Object.assign({}, row); //避免编辑内容后取消导致显示异常
      this.$util.renderExtField(this.extFields, row);
      // 解析图片字段
      if (row.images) {
        if (this.$util.isJson(row.images)) {
          row.images = JSON.parse(row.images);
        }
      } else {
        row.images = [];
      }

      // this.formData = row;
      row.typeId = row.typeId || [];
      console.log(this.formData.typeId);
      this.openDetail = true;
      this.$nextTick(() => {
        this.formData = this.$util.deepCopy(row);
        this.$forceUpdate();
      });
    },
    doSave() {
      let params = this.$util.deepCopy(this.formData);
      let typeIdStr = '';
      typeIdStr = params.typeId.toString();
      params.typeId = typeIdStr;
      this.$util.saveFormatExtField(this.extFields, params);
      this.osg.ajax('/wares/upsert.do', { data: JSON.stringify(params) }, () => {
        this.doInit();
        this.getData();
        this.osg.toast('保存成功！');
      });
      // }
    },
    doEnable(id) {
      this.osg.ajax(`basic/wares/enable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`basic/wares/disable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`/wares/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    // 列表多选
    selectRows(rows) {
      this.selectedRows = rows;
    },
    // 审核
    audit(approveState) {
      /**
       * auditStatus
       * 0:待审核（新建后是自由态-->审核状态设为0:待审核）
       * 1:审核通过（平台点审核通过-->审核状态改为1:审核通过）
       * 2:审核不通过（平台点审核通过-->审核状态改为2:审核不通过）
       */
      // 至少选择一个产品
      if (this.selectedRows.length == 0) {
        this.osg.toast('请至少勾选一条待审核的数据', 'warning');
        return;
      }
      // 判断选择的产品状态是否符合审核条件
      let msg = '';
      let confirmMsg = '';
      switch (approveState) {
        case '1':
          for (let row of this.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核通过';
          msg = '审核通过，处理完成。';
          break;
        case '2':
          for (let row of this.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核不通过';
          msg = '审核不通过，处理完成。';
          break;
        default:
      }
      this.osg.confirm(`是否确认“${confirmMsg}”？`, () => {
        this.auditConfirm(approveState, msg);
      });
    },
    auditConfirm(approveState, msg) {
      let ids = [];
      this.selectedRows.map(item => {
        ids.push(item._id);
      });
      this.osg.ajax(
        '/basic/wares/approve.do',
        {
          ids: ids.join(),
          approveState: approveState
          // data: JSON.stringify({
          //   datas: this.selectedRows,
          //   newAuditStatus: approveState,
          //   // remark: this.auditObj.remark || null
          // })
        },
        () => {
          this.osg.toast(msg);
          // this.auditObj.remark = '';
          // this.auditObj.show = false;
          this.getData();
        }
      );
    },
    getAllClassify() {
      this.osg.ajax('/biz/classify/queryWithSmooth.do', {}, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.allClassify = res.data;
      });
    },
    // parentId: '1928070664098434877', 4417047658598871409
    getClassify() {
      this.osg.ajax(
        '/biz/classify/queryClassify.do',
        {
          _all: '1',
          parentId: '4417047658598871409',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.options.classify = res.data;
        }
      );
    },
    formatClassify(row, column, cellValue) {
      return this.osg.codelabel('allClassify', cellValue);
    },
    // 材料
    getMaterial(query) {
      let params = {
        _all: 1,
        'regex:name|string#or': this.searchValue || query,
        'regex:code|string#or': this.searchValue,
        'is:state|integer#and': 1,
        'is:orgId|string#and': '1340835581184723420',
        sortField: 'order,_id',
        sortOrder: 'asc'
      };
      this.osg.ajax('basic/material/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.materials = res.data;
      });
    },
    getMeasure(query) {
      let params = {
        _all: 1,
        'regex:name|string#or': this.searchValue || query,
        'regex:code|string#or': this.searchValue,
        'is:state|integer#and': 1,
        'is:orgId|string#and': '1340835581184723420',
        sortField: 'order,_id',
        sortOrder: 'asc'
      };
      this.osg.ajax('biz/measure/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.measure = res.data;
      });
    },
    getProjPackages(query) {
      let params = {
        _all: 1,
        'regex:name|string#or': this.searchValue || query,
        'regex:code|string#or': this.searchValue,
        'is:state|integer#and': 1,
        'is:orgId|string#and': '1340835581184723420',
        sortField: 'order,_id',
        sortOrder: 'asc'
      };
      this.osg.ajax('/biz/projPackage/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.projPackages = res.data;
      });
    }
  }
};
</script>
